import React from 'react';

const HowYouCanBenefit = () => {
    const benefits = [
        {
          title: "Quality Portfolio",
          description: "Our focus on strong fundamentals and growth potential helps you build a portfolio of high-quality businesses with enduring competitive advantages."
        },
        {
          title: "Risk Management",
          description: "By investing in companies with low debt and strong cash flows, we help protect your capital during market downturns while positioning for growth during recoveries."
        },
        {
          title: "Data-Driven Decisions",
          description: "Our machine learning algorithms analyze thousands of data points to identify opportunities that human analysis alone might miss, giving you an edge in the market."
        },
        {
          title: "Long-Term Performance",
          description: "The disciplined application of our Roots & Wings philosophy is designed to deliver consistent returns over time without chasing short-term market movements."
        }
      ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            How You Can Benefit
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowYouCanBenefit;